import type { CampaignChannelKind, CampaignDeliveryMode, InstanceOutboundChannel } from '@workspace/types';

export type CampaignChannelOption = {
  kind: CampaignChannelKind;
  label: string;
  enabled: boolean;
  reason?: string;
};

const CONV_SMS_DISABLED = 'El modo conversacional admite WhatsApp o email.';
const SMS_DISABLED = 'Esta instancia no tiene SMS. Pedile al superadmin que lo habilite.';
const EMAIL_DISABLED = 'Esta instancia no tiene email. Pedile al superadmin que lo habilite.';

export function campaignChannelOptions(input: {
  deliveryMode: CampaignDeliveryMode;
  tenantHasSms: boolean;
  tenantHasEmail: boolean;
  instanceChannels: InstanceOutboundChannel[];
}): CampaignChannelOption[] {
  const instanceSet = new Set(
    input.instanceChannels.length > 0 ? input.instanceChannels : (['WHATSAPP'] as InstanceOutboundChannel[]),
  );
  const conversational = input.deliveryMode === 'CONVERSATIONAL';
  return [
    {
      kind: 'WHATSAPP',
      label: 'WhatsApp',
      enabled: instanceSet.has('WHATSAPP'),
      reason: instanceSet.has('WHATSAPP')
        ? undefined
        : 'No hay un canal de WhatsApp de contacto en esta instancia.',
    },
    smsOrEmailOption('SMS', 'SMS', conversational, input.tenantHasSms && instanceSet.has('SMS'), SMS_DISABLED),
    smsOrEmailOption(
      'EMAIL',
      'Email',
      conversational,
      input.tenantHasEmail && instanceSet.has('EMAIL'),
      EMAIL_DISABLED,
    ),
  ];
}

function smsOrEmailOption(
  kind: 'SMS' | 'EMAIL',
  label: string,
  conversational: boolean,
  entitled: boolean,
  missingReason: string,
): CampaignChannelOption {
  if (conversational) {
    if (kind === 'SMS') {
      return { kind, label, enabled: false, reason: CONV_SMS_DISABLED };
    }
    return { kind, label, enabled: entitled, reason: entitled ? undefined : missingReason };
  }
  return { kind, label, enabled: entitled, reason: entitled ? undefined : missingReason };
}

export function unionInstanceChannels(
  instances: Array<{ enabledOutboundChannels?: InstanceOutboundChannel[] }>,
): InstanceOutboundChannel[] {
  const found = new Set<InstanceOutboundChannel>();
  for (const instance of instances) {
    const channels = instance.enabledOutboundChannels ?? ['WHATSAPP'];
    for (const channel of channels) {
      found.add(channel);
    }
  }
  return [...found];
}
